export default "__VITE_ASSET__GA9jy8UB__"